/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { makeStyles } from '@mui/styles';
import {
  AppBar,
  Container,
  Typography,
  IconButton,
  Tabs,
  Tab,
  TextField,
  InputAdornment,
  Popover,
} from '@mui/material';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { useIntl } from 'react-intl';
import EventIcon from '@mui/icons-material/Event';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { openProjectNameAtom, projectsDataAtom, userDataAtom } from '../Atoms';
import ComplexityStack from '../Shared/ComplexityStack';
import Logout from '../Shared/Logout';

const useStyles = makeStyles({
  root: {
    display: 'flex',
  },
  header: {
    paddingTop: '24px',
    paddingBottom: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: '36px',
    paddingRight: '36px',
    justifyContent: 'center',
  },
  txtRow: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  txtRowDialog: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filter: {
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '1vh',
    paddingBottom: '1vh',
  },
  dialogHeader: {
    paddingTop: '16px',
    paddingBottom: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  icnWrap: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
  },
  colTxt: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  pagesTab: {
    backgroundColor: '#ffffff',
    padding: 0,
  },
  adornedEnd: {
    paddingRight: '7px  ',
  },
});

const MobileNavbar = function MobileNavbar({
  changeSection,
  sectionValue,
  setFiltersApplied,
  setSearchValue,
  searchValue,
  filtersApplied,
  setUser,
}) {
  const [openProjectName, setOpenProjectName] = useRecoilState(openProjectNameAtom);
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);
  const userData = useRecoilValue(userDataAtom);
  const intl = useIntl();
  const classes = useStyles();
  // const [showSearchBar, setShowSearchBar] = useState(false);

  const getRoleName = (roleId) => {
    if (roleId === 0) return intl.messages.ADMIN;
    if (roleId === 1) return intl.messages.PROGRAMMANAGER;
    if (roleId === 2) return intl.messages.PROJECTMANAGER;
    if (roleId === 3) return intl.messages.MONITOR;
    return intl.messages.READER;
  };

  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === openProjectName && x.isCurrent === 1));
  }, [projectsData, openProjectName]);

  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const lastChange = new Date(currentProjectData?.dataInizioValidita);
  const kickOff = new Date(currentProjectData?.KickOff);
  const sop = new Date(currentProjectData?.SopPredicted);
  const closeCounter = projectsData?.filter((x) => x.isCurrent === 1 && x.finishedPhase === 'RV7').length;
  const openCounter = projectsData?.filter((x) => x.isCurrent === 1 && x.finishedPhase !== 'RV7').length;
  const [openAccountMenu, setOpenAccountMenu] = useState(null);
  const steps = [
    {
      label: 'RV1',
      description: `${intl.messages.RV1}`,
    },
    {
      label: 'RV2',
      description: `${intl.messages.RV2}`,
    },
    {
      label: 'RV3',
      description: `${intl.messages.RV3}`,
    },
    {
      label: 'RV4',
      description: `${intl.messages.RV4}`,
    },
    {
      label: 'RV5',
      description: `${intl.messages.RV5}`,
    },
    {
      label: 'RV6',
      description: `${intl.messages.RV6}`,
    },
    {
      label: 'RV7',
      description: `${intl.messages.RV7}`,
    },
  ];
  const getCurrentStep = (value) => {
    let index = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < steps.length; i++) {
      if (steps[i].label.substring(0, 3) === value) {
        index = i + 1;
      }
    }
    if (index === 0) return 0;
    return index;
  };

  const open = Boolean(openAccountMenu);
  return (
    <AppBar sx={{ position: 'sticky' }}>
      {!openProjectName && (
        <div className="firstPage">
          <Container className={classes.header}>
            <IconButton sx={{ mb: 1 }} onClick={() => setOpenAccountMenu(true)} id="logout">
              <AccountCircleOutlinedIcon color="white" />
            </IconButton>
            <Popover
              id="logout"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              anchorEl={openAccountMenu}
              open={open}
              onClose={() => setOpenAccountMenu(null)}
            >
              <Logout setUser={setUser} />
            </Popover>
            <Typography variant="caption" color="secWhite" lineHeight={0.5}>
              {getRoleName(userData?.ruolo)}
            </Typography>
            <Typography variant="h6" component="span" mb={2}>
              {userData?.nome} {userData?.cognome}
            </Typography>
            <Container className={classes.txtRow} sx={{ width: '100%' }}>
              <div className={classes.txtRow}>
                <Typography variant="caption" color="secWhite">
                  {intl.messages.OPEN}:
                </Typography>
                <Typography variant="body2" ml={0.5}>
                  {openCounter}
                </Typography>
              </div>
              <div className={classes.txtRow}>
                <Typography variant="caption" color="secWhite">
                  {intl.messages.CLOSED}:
                </Typography>
                <Typography variant="body2" ml={0.5}>
                  {closeCounter}
                </Typography>
              </div>
            </Container>
          </Container>
          <Container className={classes.filter}>
            <TextField
              fullWidth
              size="small"
              id="searchbar"
              value={searchValue || ''}
              onChange={(e) => setSearchValue(e.target.value)}
              InputLabelProps={{ shrink: false }}
              placeholder={`${intl.messages.SEARCH}...`}
              InputProps={{
                endAdornment: filtersApplied ? (
                  <InputAdornment
                    position="end"
                    onClick={() => {
                      setSearchValue(null);
                      setFiltersApplied(false);
                    }}
                  >
                    <CloseIcon />
                  </InputAdornment>
                ) : (
                  <InputAdornment
                    position="end"
                    onClick={() => {
                      setFiltersApplied(true);
                    }}
                  >
                    <SearchIcon />
                  </InputAdornment>
                ),
                classes: {
                  adornedEnd: classes.endAdornment,
                },
              }}
              variant="outlined"
            />
          </Container>
        </div>
      )}
      {openProjectName && (
        <div>
          <div className={classes.root}>
            <div>
              <IconButton onClick={() => setOpenProjectName(null)}>
                <ArrowBackIcon color="white" />
              </IconButton>
            </div>
            <div style={{ width: '100%', paddingRight: '16px', paddingLeft: '8px' }}>
              <Container disableGutters className={classes.dialogHeader}>
                <Typography variant="h6" component="span" mb={2} lineHeight={0.5}>
                  {currentProjectData?.Name}
                </Typography>
                <Typography variant="caption" color="secWhite" mb={2}>
                  {currentProjectData?.Client} {currentProjectData?.RagSociale}
                </Typography>
                <div className={classes.icnWrap}>
                  <EventIcon sx={{ mr: '2%' }} />
                  <div className={classes.colTxt}>
                    <Typography variant="caption" color="secWhite" lineHeight={1}>
                      Dates
                    </Typography>
                    <Typography variant="body2">{`${kickOff.toLocaleDateString(
                      undefined,
                      options
                    )} - ${sop.toLocaleDateString(undefined, options)}`}</Typography>
                  </div>
                </div>
                <div className={classes.txtRowDialog} style={{ width: '100%' }}>
                  <div className={classes.colTxt}>
                    <Typography variant="caption" color="secWhite">
                      Compl.
                    </Typography>
                    <ComplexityStack projectName={openProjectName} />
                  </div>
                  <div className={classes.colTxt}>
                    <Typography variant="caption" color="secWhite">
                      Fase APQP
                    </Typography>
                    <Typography variant="body2" ml={0.5}>
                      {`RV${getCurrentStep(currentProjectData?.finishedPhase) + 1}`}
                    </Typography>
                  </div>
                  <div className={classes.colTxt}>
                    <Typography variant="caption" color="secWhite">
                      Last ch.:
                    </Typography>
                    <Typography variant="body2" ml={0.5}>
                      {lastChange.toLocaleDateString(undefined, options)}
                    </Typography>
                  </div>
                </div>
              </Container>
            </div>
          </div>
          <Container className={classes.pagesTab}>
            <Tabs value={sectionValue || 0} onChange={changeSection} variant="fullWidth">
              <Tab label="IN" value={0} />
              <Tab label="OUT" value={1} />
              <Tab label="RADAR" value={2} />
            </Tabs>
          </Container>
        </div>
      )}
    </AppBar>
  );
};

export default MobileNavbar;
